export default {"src":"/_next/static/media/baseStepElements.cf71928e.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};